import { useMutation } from '@tanstack/react-query';
import { setDeviceQueue } from '../services/api';

interface SetDeviceQueueParams {
    userId: string;
    deviceId: string;
    channelId: string;
    artworks?: any[];
}

export function useSetDeviceQueue() {
    return useMutation({
        mutationFn: async (params: SetDeviceQueueParams) => {
            const response = await setDeviceQueue({
                deviceId: params.deviceId,
                channelId: params.channelId,
                artworks: params.artworks,
            });
            return response.data;
        },
    });
}
